export default class PromoCodeAction {
  static get DishGift () { return 'dishGift' }
  static get Doubling () { return 'doubling' }
  static get DoublingMarked () { return 'doubling_marked' }
  static get BirthDay () { return 'birthDay' }
  static get BirthDayRelative () { return 'birth_day_relative' }
  static get FriendPercent () { return 'friendPercent' }
  static get Subtract () { return 'subtract' }
  static get Percent () { return 'percent' }
  static get FoxCoinAdd () { return 'fox_coin_add' }
  static get FoxCoinPay () { return 'fox_coin_pay' }
}
